import styled from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'
import { ICONS } from '../../themes'
// Wrapper
// ============================================================
export const SideBarStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  display: flex;
  width: ${VARIABLES.ELEMENT_SIZES.SIDEBAR_WIDTH + 'px'};
  background-color: #4b4acb;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${VARIABLES.Z_INDEXS.LV_5};
  box-shadow: none;
  padding: 0 0 16px;
  overflow-x: hidden;
  overflow-y: auto;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: flex-start;

  .sidebar-brand {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    flex: 0 0 auto;
    padding: 20px 16px;
    text-decoration: none;
  }

  .sidebar-brand-mark {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    flex: 0 0 36px;
    border-radius: 12px;
    background-color: #6c63ff;

    svg {
      width: 20px;
      height: 20px;
      fill: #ffffff;
    }
  }

  .sidebar-brand-text {
    display: flex;
    flex-direction: column;
    line-height: 1.15;
  }

  .sidebar-brand-name {
    color: #ffffff;
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.04em;
  }

  .sidebar-brand-sub {
    color: rgba(227, 225, 255, 0.6);
    font-size: 11px;
  }
  &.sidebar {
    .is-open {
      .accordion-body {
        margin-top: 20px;
      }
      .accordion-head {
        .toggle-icon {
          &:after {
            content: '';
            background: url(${ICONS['icon-arrow-up.svg']}) no-repeat 0 0;
            background-size: 100%;
          }
        }
      }
      .accordion-head:hover {
        .toggle-icon {
          &:after {
            content: '';
            background: url(${ICONS['icon-arrow-up.svg']}) no-repeat 0 0;
            background-size: 100%;
          }
        }
      }
    }

    .toggle-icon {
      width: 16px;
      height: 16px;
      border: none;
      &:after {
        position: relative;
        top: 3px;
        left: 3px;
        width: 16px;
        height: 16px;
        margin-right: 5px;
        content: '';
        background: url(${ICONS['icon-arrow-down.svg']}) no-repeat 0 0;
        background-size: 100%;
        filter: brightness(0) invert(1);
        opacity: 0.75;
      }
    }
    /* .accordion-head:hover {
      .toggle-icon {
        &:after {
          content: '';
          background: url(${ICONS['icon-arrow-down-white.svg']}) no-repeat 0 0;
          background-size: 100%;
        }
      }
    } */
    .accordion-head {
      color: #e3e1ff;
      margin-bottom: 0;
    }
    .accordion-body {
      margin-top: 4px;
      transition: none;
      padding: 0;
      position: relative;
      .menu-children {
        display: flex;
        padding: 8px 12px;
        margin: 2px 8px;
        width: auto;
        border-radius: 12px;
        color: rgba(227, 225, 255, 0.72);
      }
      .menu-children:hover {
        color: white;
        background-color: #5c56d6;
      }
      .isActive-children {
        color: white;
        background-color: #6c63ff;
      }
    }
  }
  /* Child element styles
  ------------------------------- */

  /* Modifiers
  ------------------------------- */

  /* Modifiers for single UI
  ------------------------------- */

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1600.98px) {
    width: ${VARIABLES.ELEMENT_SIZES.SIDEBAR_WIDTH_XL + 'px'};
  }

  @media all and (max-width: 1440.98px) {
    width: ${VARIABLES.ELEMENT_SIZES.SIDEBAR_WIDTH_LG + 'px'};
  }

  @media all and (max-width: 1366.98px) {
    width: ${VARIABLES.ELEMENT_SIZES.SIDEBAR_WIDTH_MD + 'px'};
  }

  @media all and (max-width: 1280.98px) {
    width: ${VARIABLES.ELEMENT_SIZES.SIDEBAR_WIDTH_SM + 'px'};
  }

  @media all and (max-width: 1024.98px) {
    width: ${VARIABLES.ELEMENT_SIZES.SIDEBAR_WIDTH_XS + 'px'};
  }
`

export const SideBarItemStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  display: flex;
  height: auto;
  width: calc(100% - 16px);
  margin: 2px 8px;
  padding: 10px 12px;
  border-radius: 12px;
  align-items: center;
  cursor: pointer;

  /* Child element styles
  ------------------------------- */
  .image-control {
    min-height: 25px;
    min-width: 25px;
    height: 25px;
    flex: 0 0 25px;
    margin-right: 13px;

    .image {
      width: auto;
      height: 100%;
      vertical-align: initial;
      filter: brightness(0) invert(1);
      opacity: 0.65;
    }
  }

  .icon-spacing {
    min-height: 25px;
    min-width: 25px;
    flex: 0 0 25px;
    margin-right: 13px;
  }

  .menu-name {
    flex: 1 1 auto;
    color: rgba(227, 225, 255, 0.78);
    line-height: 20px;
    font-size: 14px;
    font-weight: 500;
  }

  /* Modifiers
  ------------------------------- */
  &.is-disable {
    cursor: initial;

    &:hover {
      background-color: transparent !important;

      .menu-name {
        color: rgba(227, 225, 255, 0.45) !important;
      }
    }

    &.is-active {
      background-color: transparent !important;

      .menu-name {
        color: rgba(227, 225, 255, 0.45) !important;
      }
    }
  }

  /* State
  ------------------------------- */
  &:hover {
    background-color: #5c56d6;

    .image-control .image {
      opacity: 0.9;
    }

    .accordion-head {
      .toggle-icon {
        &:after {
          content: '';
          background: url(${ICONS['icon-arrow-down-white.svg']}) no-repeat 0 0;
          background-size: 100%;
        }
      }
    }
    .menu-name {
      color: white;
    }
  }

  &.is-active {
    background-color: #6c63ff;
    box-shadow: 0 8px 16px rgba(108, 99, 255, 0.28);

    .image-control .image {
      opacity: 1;
    }

    .menu-name {
      color: white;
    }
  }

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1600.98px) {
    height: 48px;
    padding: 10px 9px 10px 18px;

    .image-control,
    .icon-spacing {
      min-height: 23px;
      min-width: 23px;
      height: 23px;
      flex: 0 0 23px;
      margin-right: 12px;
    }
  }

  @media all and (max-width: 1440.98px) {
    height: 46px;
    padding: 9px 8px 9px 17px;

    .image-control,
    .icon-spacing {
      min-height: 21px;
      min-width: 21px;
      height: 21px;
      flex: 0 0 21px;
      margin-right: 11px;
    }
  }

  @media all and (max-width: 1366.98px) {
    height: 44px;
    padding: 8px 7px 8px 15px;

    .image-control,
    .icon-spacing {
      min-height: 19px;
      min-width: 19px;
      height: 19px;
      flex: 0 0 19px;
      margin-right: 10px;
    }
  }

  @media all and (max-width: 1280.98px) {
    height: 42px;
    padding: 7px 14px;

    .image-control,
    .icon-spacing {
      min-height: 17px;
      min-width: 17px;
      height: 17px;
      flex: 0 0 17px;
      margin-right: 9px;
    }
  }

  @media all and (max-width: 1024.98px) {
    height: 40px;
    padding: 5px 12px;

    .image-control,
    .icon-spacing {
      min-height: 15px;
      min-width: 15px;
      height: 15px;
      flex: 0 0 15px;
      margin-right: 8px;
    }
  }
`
